import SelectItemInterface from "@/models/components/inputs/selectItem";
import { Expose } from "class-transformer";
export class SelectItem implements SelectItemInterface {
  @Expose()
  text!: string;
  @Expose()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value!: any;
}
